import React, { useState, useEffect, useRef } from "react";
import botFlow from "../data/botFlow";
import "./ChatBot.css";

import logoHLP from "../assets/images/logo/logoHLPPreto.png";
import roboEntrega from "../assets/images/robots/roboEntrega.png";
import roboLimpeza from "../assets/images/robots/roboLimpeza.png";
import roboRefeicao from "../assets/images/robots/roboRefeicao.png";
import roboLogistica from "../assets/images/robots/roboLogistica.png";

function ChatBot() {
  const [currentState, setCurrentState] = useState("MAIN_MENU");
  const [messages, setMessages] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const [isTyping, setIsTyping] = useState(false);


  const [userName, setUserName] = useState("");
  const [isWaitingName, setIsWaitingName] = useState(true);
  const [inputValue, setInputValue] = useState("");

  // 🔹 SUPORTE
  const [supportStep, setSupportStep] = useState(null);
  const [supportData, setSupportData] = useState({
    company: "",
    robot: "",
    issue: "",
    address: "",
  });

  // 🔹 FINANCEIRO
  const [financeStep, setFinanceStep] = useState(null);
  const [financeData, setFinanceData] = useState({
    robot: "",
    company: "",
    financialIssue: "",
  });

  // 🔹 ORÇAMENTO
  const [budgetStep, setBudgetStep] = useState(null);
  const [budgetData, setBudgetData] = useState({
    company: "",
    niche: "",
    robot: "",
    budgetInterest: "",
  });

  const supportRobotOptions = [
  { label: "Robô Entregador" },
  { label: "Robô Garçom" },
  { label: "Robô de Limpeza" },
  { label: "Robô de Logística" },
];

const supportIssueOptions = [
  { label: "Ele parou de funcionar" },
  { label: "Quero adicionar uma funcionalidade nele" },
  { label: "Sofreu um acidente" },
  { label: "Outro tipo de ajuda" },
];

const financeInitialOptions = [
  { label: "Sim" },
  { label: "Não" },
];

const financeRobotOptions = [
  { label: "Robô Entregador" },
  { label: "Robô Garçom" },
  { label: "Robô de Limpeza" },
  { label: "Robô de Logística" },
  { label: "⬅ Voltar ao menu inicial" },
];

const financeIssueOptions = [
  { label: "Solicitar segunda via de boleto" },
  { label: "Negociar vencimento" },
  { label: "Dúvida sobre cobrança" },
  { label: "Atualizar dados cadastrais" },
];

const budgetRobotOptions = [
  { label: "Robô Entregador" },
  { label: "Robô Garçom" },
  { label: "Robô de Limpeza" },
  { label: "Robô de Logística" },
];

const budgetInterestOptions = [
  { label: "Compra do robô" },
  { label: "Locação mensal" },
  { label: "Plano personalizado para minha empresa" },
  { label: "Quero entender valores e condições" },
];

  const messagesEndRef = useRef(null);
  const hasStarted = useRef(false);

  const currentNode = botFlow[currentState];

  /* ========================= */
  /* INÍCIO - PERGUNTA NOME   */
  /* ========================= */

  useEffect(() => {
    if (!hasStarted.current) {
      hasStarted.current = true;

      setIsTyping(true);

      setTimeout(() => {
        setIsTyping(false);
        addBotMessage(
          "Olá 👋 Antes de iniciarmos seu atendimento, poderia me informar seu nome?"
        );
        setIsWaitingName(true);
      }, 1200);
    }
  }, []);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isTyping]);

  const addBotMessage = (content, image) => {
    setMessages((prev) => [...prev, { sender: "bot", content, image }]);
  };

  const addUserMessage = (content) => {
    setMessages((prev) => [...prev, { sender: "user", content }]);
  };

  /* ========================= */
  /* FLUXO NORMAL BOT         */
  /* ========================= */

  const startBotFlow = (stateKey, skipMessage = false) => {
    const node = botFlow[stateKey];

    setShowOptions(false);
    setIsTyping(true);
    setCurrentState(stateKey);

    setTimeout(() => {
      setIsTyping(false);

      if (!skipMessage) {
        addBotMessage(node.description || node.message, node.image);
      }

      setShowOptions(true);
    }, 1200);
  };

    const startFinanceFlow = () => {
      setSupportStep(null);
      setCurrentState(null); // 🔥 remove o menu principal corretamente
      setShowOptions(true);
      setFinanceStep("IS_CLIENT");

      addBotMessage("Você já é nosso cliente?");
    };

    const startBudgetFlow = () => {
      setSupportStep(null);
      setFinanceStep(null);
      setCurrentState(null);
      setShowOptions(false);

      setIsTyping(true);

      setTimeout(() => {
        setIsTyping(false);
        addBotMessage("Perfeito! 😊 Para montar seu orçamento, preciso de algumas informações.\n\nQual o nome da sua empresa?");
        setBudgetStep("COMPANY");
      }, 1000);
    };

  /* ========================= */
  /* FLUXO SUPORTE            */
  /* ========================= */

  const startSupportFlow = () => {
    setShowOptions(false);
    setIsTyping(true);

    setTimeout(() => {
      setIsTyping(false);
      addBotMessage(
        "Para iniciarmos o atendimento técnico, preciso de algumas informações.\n\nQual o nome da sua empresa?"
      );
      setSupportStep("COMPANY");
    }, 1000);
  };

  const sendSupportToWhatsApp = () => {
    const { company, robot, issue, address } = supportData;

    const message = encodeURIComponent(
      `Olá, me chamo ${userName}.
      Preciso de suporte para o meu ${robot}.
      Empresa: ${company}
      Motivo: ${issue}
      Endereço: ${address}`
    );

    addBotMessage(
      "Obrigado pelas informações. Você está sendo direcionado para nossa equipe técnica especializada."
    );

    setTimeout(() => {
      window.open(
        `https://wa.me/5511967390981?text=${message}`,
        "_blank"
      );
    }, 1500);

    setTimeout(() => {
      setSupportStep(null);
      setSupportData({
        company: "",
        robot: "",
        issue: "",
        address: "",
      });
      startBotFlow("MAIN_MENU");
    }, 3000);
  };

  /* ========================= */
  /* INPUT SUBMIT (GENÉRICO)  */
  /* ========================= */

  const handleInputSubmit = () => {
    if (!inputValue.trim()) return;

    const value = inputValue.trim();
    addUserMessage(value);
    setInputValue("");

    // 🔹 NOME
    if (isWaitingName) {
      setUserName(value);
      setIsWaitingName(false);

      setIsTyping(true);
      setTimeout(() => {
        setIsTyping(false);
        addBotMessage(`Prazer, ${value}! 😊 Como posso te ajudar hoje?`);
        startBotFlow("MAIN_MENU", true);
      }, 1000);
      return;
    }

    // 🔹 SUPORTE - EMPRESA
    if (supportStep === "COMPANY") {
      setSupportData((prev) => ({ ...prev, company: value }));

      setIsTyping(true);
      setTimeout(() => {
        setIsTyping(false);
        addBotMessage("Qual modelo de robô precisa de suporte?");
        setSupportStep("ROBOT");
        setShowOptions(true);
      }, 1000);
      return;
    }

    // 🔹 SUPORTE - ENDEREÇO
    if (supportStep === "ADDRESS") {
      setSupportData((prev) => ({ ...prev, address: value }));
      sendSupportToWhatsApp();
      return;
    }

    // 🔹 FINANCEIRO - EMPRESA
    if (financeStep === "COMPANY") {
      setFinanceData((prev) => ({ ...prev, company: value }));

      setIsTyping(true);
      setTimeout(() => {
        setIsTyping(false);
        addBotMessage("Qual assunto financeiro você gostaria de tratar?");
        setFinanceStep("ISSUE");
        setShowOptions(true);
      }, 1000);
      return;
    }

    if (budgetStep === "COMPANY") {
      setBudgetData((prev) => ({ ...prev, company: value }));

      setIsTyping(true);
      setTimeout(() => {
        setIsTyping(false);
        addBotMessage("Qual nicho da sua empresa?");
        setBudgetStep("NICHE");
      }, 1000);
      return;
    }

    if (budgetStep === "NICHE") {
      setBudgetData((prev) => ({ ...prev, niche: value }));

      setIsTyping(true);
      setTimeout(() => {
        setIsTyping(false);
        addBotMessage("Qual robô você gostaria de conhecer?");
        setBudgetStep("ROBOT");
        setShowOptions(true);
      }, 1000);
      return;
    }
    
  };

  /* ========================= */
  /* CLIQUE BOTÕES            */
  /* ========================= */

  const handleOptionClick = (option) => {
    setShowOptions(false);

    // 🔹 SOLICITAR ORÇAMENTO PERSONALIZADO
// 🔹 SOLICITAR ORÇAMENTO PERSONALIZADO
if (option.label === "💰 Solicitar orçamento") {

  const robotName = currentNode?.description?.includes("Garçom")
    ? "Robô Garçom"
    : currentNode?.description?.includes("Entrega")
    ? "Robô Entregador"
    : currentNode?.description?.includes("Limpeza")
    ? "Robô de Limpeza"
    : currentNode?.description?.includes("Logística")
    ? "Robô de Logística"
    : "robô";

  const message = encodeURIComponent(
    `Olá! Gostaria de mais informações sobre o valor do ${robotName}.`
  );

  window.open(
    `https://wa.me/5511976030954?text=${message}`,
    "_blank"
  );

  // 🔹 Mensagem após redirecionar
  setIsTyping(true);

  setTimeout(() => {
    setIsTyping(false);

    addBotMessage(
      "Perfeito! 😊 Enquanto nossa equipe comercial te atende, posso ajudar com mais alguma coisa?"
    );

    setCurrentState("POST_ORCAMENTO"); 
    setShowOptions(true);
  }, 1000);

  return;
}

    // 🔹 INICIAR SUPORTE
    if (option.next === "SUPORTE_MENU") {
      startSupportFlow();
      return;
    }

    addUserMessage(option.label);

    // 🔹 SUPORTE - ROBÔ
    if (supportStep === "ROBOT") {
      setSupportData((prev) => ({ ...prev, robot: option.label }));

      setIsTyping(true);
      setTimeout(() => {
        setIsTyping(false);
        addBotMessage(
          "Qual tipo de suporte você precisa?",
        );
        setSupportStep("ISSUE");
        setShowOptions(true);
      }, 1000);
      return;
    }

    const financeInitialOptions = [
      { label: "Sim" },
      { label: "Não" },
    ];

    const financeRobotOptions = [
      { label: "Robô Entregador" },
      { label: "Robô Garçom" },
      { label: "Robô de Limpeza" },
      { label: "Robô de Logística" },
      { label: "⬅ Voltar ao menu inicial" },
    ];

    const financeIssueOptions = [
      { label: "Solicitar segunda via de boleto" },
      { label: "Negociar vencimento" },
      { label: "Dúvida sobre cobrança" },
      { label: "Atualizar dados cadastrais" },
    ];

    // 🔹 SUPORTE - PROBLEMA
    if (supportStep === "ISSUE") {
      setSupportData((prev) => ({ ...prev, issue: option.label }));

      setIsTyping(true);
      setTimeout(() => {
        setIsTyping(false);
        addBotMessage(
          "Por favor, informe o endereço onde o robô está localizado."
        );
        setSupportStep("ADDRESS");
      }, 1000);
      return;
    }

      // 🔹 QUALQUER AÇÃO QUE CONTENHA "WHATSAPP"
      if (option.action && option.action.includes("WHATSAPP")) {

        const message = encodeURIComponent(
          `Olá! Me chamo ${userName} e gostaria de falar com um especialista.`
        );

        window.open(
          `https://wa.me/5511976030954?text=${message}`,
          "_blank"
        );

        setIsTyping(true);

        setTimeout(() => {
          setIsTyping(false);

          addBotMessage(
            "Perfeito! 😊 Nossa equipe já foi acionada. Posso te ajudar com mais alguma coisa?"
          );

          startBotFlow("MAIN_MENU");
        }, 1000);

        return;
      }

    // 🔹 INICIAR FINANCEIRO
    if (option.next === "FINANCEIRO_MENU") {
      startFinanceFlow();
      return;
    }

    // 🔹 FINANCEIRO - JÁ É CLIENTE?
    if (financeStep === "IS_CLIENT") {
 
      if (option.label === "Não") {
        setFinanceStep(null);
        startBotFlow("ROBOT_TYPES");
        return;
      }

      if (option.label === "Sim") {
        setIsTyping(true);
        setTimeout(() => {
          setIsTyping(false);
          addBotMessage("Qual robô HLP você possui atualmente?");
          setFinanceStep("ROBOT");
          setShowOptions(true);
        }, 1000);
        return;
      }
    }

    if (financeStep === "ROBOT") {
      if (option.label.includes("Voltar")) {
        setFinanceStep(null);
        startBotFlow("MAIN_MENU");
        return;
      }

      setFinanceData((prev) => ({ ...prev, robot: option.label }));

      setIsTyping(true);
      setTimeout(() => {
        setIsTyping(false);
        addBotMessage("Qual o nome da sua empresa?");
        setFinanceStep("COMPANY");
      }, 1000);

      return;
    }

    if (financeStep === "ISSUE") {
      setFinanceData((prev) => ({ ...prev, financialIssue: option.label }));

      const message = encodeURIComponent(
        `Olá! Me chamo ${userName} da empresa ${financeData.company} e gostaria de tratar do seguinte assunto financeiro: ${option.label}`
      );

      addBotMessage("Perfeito! Estamos te direcionando para nosso setor financeiro.");

      setTimeout(() => {
        window.open(
          `https://wa.me/5511976030954?text=${message}`,
          "_blank"
        );
      }, 1500);

      setTimeout(() => {
        setFinanceStep(null);
        setFinanceData({
          robot: "",
          company: "",
          financialIssue: "",
        });
        startBotFlow("MAIN_MENU");
      }, 3000);

      return;
    }

    // 🔹 INICIAR ORÇAMENTO
    if (option.next === "VALORES_ORCAMENTO") {
      startBudgetFlow();
      return;
    }

    if (budgetStep === "ROBOT") {

  setBudgetData((prev) => ({ ...prev, robot: option.label }));

  setIsTyping(true);

  setTimeout(() => {
    setIsTyping(false);
    addBotMessage("O que você gostaria de saber especificamente?");
    setBudgetStep("INTEREST");
    setShowOptions(true);
  }, 1000);

  return;
  }

  if (budgetStep === "INTEREST") {

  const finalData = {
    ...budgetData,
    budgetInterest: option.label,
  };

  const message = encodeURIComponent(
    `Olá, me chamo ${userName}, da empresa ${finalData.company}, somos uma empresa ${finalData.niche} e gostaria de saber ${finalData.budgetInterest}, do robô ${finalData.robot}.`
  );

  addBotMessage("Perfeito! 😊 Estamos te direcionando para nosso time comercial.");

  setTimeout(() => {
    window.open(
      `https://wa.me/5511976030954?text=${message}`,
      "_blank"
    );
  }, 1500);

  setTimeout(() => {
    setBudgetStep(null);
    setBudgetData({
      company: "",
      niche: "",
      robot: "",
      budgetInterest: "",
    });

    startBotFlow("MAIN_MENU");
  }, 3000);

  return;
  }


    // 🔹 DEMAIS FLUXOS
    if (option.next) {
      startBotFlow(option.next);
    }
  };

  /* ========================= */
  /* RENDER IMAGENS ROBÔS     */
  /* ========================= */

  const renderRobotImage = (imageName) => {
    switch (imageName) {
      case "roboEntrega":
        return roboEntrega;
      case "roboLimpeza":
        return roboLimpeza;
      case "roboRefeicao":
        return roboRefeicao;
      case "roboLogistica":
        return roboLogistica;
      default:
        return null;
    }
  };

  /* ========================= */
  /* RENDER                   */
  /* ========================= */

  return (
    <div className="chat-container">
      <div className="chat-box">
        <div className="chat-header">
          <img src={logoHLP} alt="HLP Logo" className="logo" />
        </div>

        <div className="chat-messages">
          {messages.map((msg, index) => (
            <div key={index} className={`message ${msg.sender}`}>
              {msg.image && (
                <img
                  src={renderRobotImage(msg.image)}
                  alt="Robot"
                  className="robot-image"
                />
              )}

              <div
                dangerouslySetInnerHTML={{
                  __html: msg.content
                    ?.replace(/\n/g, "<br/>")
                    .replace(
                      /(https?:\/\/[^\s]+)/g,
                      '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
                    ),
                }}
              />
            </div>
          ))}

          {isTyping && (
            <div className="message bot typing">
              Digitando<span>.</span><span>.</span><span>.</span>
            </div>
          )}

          <div ref={messagesEndRef} />
        </div>

          {showOptions && 
          !supportStep && 
          !financeStep &&
          !budgetStep &&
          currentNode?.options && (
          <div className="chat-options">
            {currentNode.options.map((option, index) => (
              <button
                key={index}
                className="chat-button"
                onClick={() => handleOptionClick(option)}
              >
                {option.label}
              </button>
            ))}
          </div>
        )}

        {showOptions && supportStep === "ROBOT" && (
        <div className="chat-options">
          {supportRobotOptions.map((option, index) => (
            <button
              key={index}
              className="chat-button"
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}

        {showOptions && supportStep === "ISSUE" && (
          <div className="chat-options">
            {supportIssueOptions.map((option, index) => (
              <button
                key={index}
                className="chat-button"
                onClick={() => handleOptionClick(option)}
              >
                {option.label}
              </button>
            ))}
          </div>
        )}

        {/* 🔹 FINANCEIRO - JÁ É CLIENTE */}
      {showOptions && financeStep === "IS_CLIENT" && (
        <div className="chat-options">
          {financeInitialOptions.map((option, index) => (
            <button
              key={index}
              className="chat-button"
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}

    {/* 🔹 FINANCEIRO - ROBÔ */}
    {showOptions && financeStep === "ROBOT" && (
      <div className="chat-options">
        {financeRobotOptions.map((option, index) => (
          <button
            key={index}
            className="chat-button"
            onClick={() => handleOptionClick(option)}
          >
            {option.label}
          </button>
        ))}
      </div>
    )}

    {/* 🔹 FINANCEIRO - ASSUNTO */}
    {showOptions && financeStep === "ISSUE" && (
      <div className="chat-options">
        {financeIssueOptions.map((option, index) => (
          <button
            key={index}
            className="chat-button"
            onClick={() => handleOptionClick(option)}
          >
            {option.label}
          </button>
        ))}
      </div>
    )}

    {showOptions && budgetStep === "ROBOT" && (
      <div className="chat-options">
        {budgetRobotOptions.map((option, index) => (
          <button
            key={index}
            className="chat-button"
            onClick={() => handleOptionClick(option)}
          >
            {option.label}
          </button>
        ))}
      </div>
    )}

    {showOptions && budgetStep === "INTEREST" && (
    <div className="chat-options">
      {budgetInterestOptions.map((option, index) => (
        <button
          key={index}
          className="chat-button"
          onClick={() => handleOptionClick(option)}
        >
          {option.label}
        </button>
      ))}
    </div>
  )}


      {(
        isWaitingName || 
        supportStep === "COMPANY" || 
        supportStep === "ADDRESS" ||
        financeStep === "COMPANY" ||
        budgetStep === "COMPANY" ||
        budgetStep === "NICHE"
      ) && (
        <div className="chat-input-area">
          <input
            type="text"
            placeholder="Digite aqui..."
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleInputSubmit();
            }}
          />
          <button onClick={handleInputSubmit}>➤</button>
        </div>
      )}
      </div>
    </div>
  );
}

export default ChatBot;